var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg14(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 29,
    viewBox: "0 0 24 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_417_614)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.37321 24.8286H0.396429V8.80534H5.37321V24.8286ZM2.88214 6.61962C1.29107 6.61962 0 5.30177 0 3.7107C0 2.9463 0.303653 2.21322 0.84416 1.67271C1.38467 1.13221 2.11775 0.828552 2.88214 0.828552C3.64653 0.828552 4.37962 1.13221 4.92013 1.67271C5.46063 2.21322 5.76429 2.9463 5.76429 3.7107C5.76429 5.30177 4.47321 6.61962 2.88214 6.61962ZM23.9946 24.8286H19.0286V17.0286C19.0286 15.1696 18.9911 12.7857 16.4411 12.7857C13.8536 12.7857 13.4571 14.8053 13.4571 16.8946V24.8286H8.48571V8.80534H13.2589V10.9911H13.3286C13.9929 9.73212 15.6161 8.40355 18.0375 8.40355C23.0732 8.40355 24 11.7196 24 16.0268V24.8286H23.9946Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_417_614"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 27.4286,
    fill: "white",
    transform: "translate(0 0.828552)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg14);
export default __webpack_public_path__ + "static/media/1 (4).4e97eab991fb120c62191cdca4ed9547.svg";
export { ForwardRef as ReactComponent };